module.exports = __webpack_public_path__ + "static/media/hu.70eee4dd.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/hu.svg
// module id = 1060
// module chunks = 0